import { Injectable } from '@angular/core';
import { UserInfo } from '@memberjunction/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class UserService {
  private userInfo!: UserInfo;

  constructor() { }

  public userInfoSource = new BehaviorSubject<boolean>(false);
  getUserComplete$ = this.userInfoSource.asObservable();

  setUserInfo(user: UserInfo): void {
    this.userInfo = user;
    this.userInfoSource.next(true);
  }

  getUserInfo(): UserInfo {
    return this.userInfo;
  }

}